import styled from 'styled-components'
import { COLORS } from '~/shared/constants/uiConstants'

export const FactCaption = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GRAY_700};
  margin-bottom: 8px;
`
